export interface LicenseFormatConfig {
  provinceId: number;
  provinceCode: string;
  provinceName: string;
  mask: string;
  minLength: number;
  maxLength: number;
  example: string;
  description: string;
  alternativeMasks?: string[];
}

export const PROVINCE_IDS = {
  ONTARIO: 1,
  ALBERTA: 2,
  BRITISH_COLUMBIA: 3,
  MANITOBA: 4,
  NEW_BRUNSWICK: 5,
  NEWFOUNDLAND: 6,
  NOVA_SCOTIA: 7,
  SASKATCHEWAN: 8,
  PEI: 9,
  QUEBEC: 10,
  YUKON: 11,
  NWT: 12,
  NUNAVUT: 13,
} as const;

export type ProvinceId = (typeof PROVINCE_IDS)[keyof typeof PROVINCE_IDS];

export const LICENSE_FORMATS: Record<number, LicenseFormatConfig> = {
  [PROVINCE_IDS.ONTARIO]: {
    provinceId: PROVINCE_IDS.ONTARIO,
    provinceCode: 'ON',
    provinceName: 'Ontario',
    mask: 'A9999-99999-99999',
    minLength: 15,
    maxLength: 15,
    example: 'A1234-12345-12345',
    description: 'Letter + 14 digits with hyphens',
  },
  [PROVINCE_IDS.ALBERTA]: {
    provinceId: PROVINCE_IDS.ALBERTA,
    provinceCode: 'AB',
    provinceName: 'Alberta',
    mask: '999999-999',
    minLength: 6,
    maxLength: 9,
    example: '123456 or 123456-789',
    description: '6-9 alphanumeric characters',
  },
  [PROVINCE_IDS.NEW_BRUNSWICK]: {
    provinceId: PROVINCE_IDS.NEW_BRUNSWICK,
    provinceCode: 'NB',
    provinceName: 'New Brunswick',
    mask: '9999999',
    minLength: 5,
    maxLength: 7,
    example: '12345 or 1234567',
    description: '5-7 digits',
  },
  [PROVINCE_IDS.NOVA_SCOTIA]: {
    provinceId: PROVINCE_IDS.NOVA_SCOTIA,
    provinceCode: 'NS',
    provinceName: 'Nova Scotia',
    mask: 'AAAAA-999999-999',
    minLength: 11,
    maxLength: 14,
    example: 'SMITH-123456-789',
    description: '5 letters + 6-9 digits',
    alternativeMasks: ['AAAAA-999999'],
  },
};

export const ALL_PROVINCES = Object.values(LICENSE_FORMATS).map((config) => ({
  value: config.provinceId,
  label: config.provinceName,
  code: config.provinceCode,
}));

export const PROVINCE_ID_TO_CODE_MAP: Record<number, string> = Object.values(
  LICENSE_FORMATS,
).reduce(
  (acc, config) => {
    acc[config.provinceId] = config.provinceCode;
    return acc;
  },
  {} as Record<number, string>,
);

export const PROVINCE_CODE_TO_ID_MAP: Record<string, number> = Object.values(
  LICENSE_FORMATS,
).reduce(
  (acc, config) => {
    acc[config.provinceCode] = config.provinceId;
    return acc;
  },
  {} as Record<string, number>,
);
